import React, {useEffect, useState} from 'react'
import {ModeleMotif, modeleMotifRefusInitValues} from '../../../components/Models'
import {useNavigate, useParams} from 'react-router-dom'
import {editMotif, getOneMotif} from '../../../components/requests'
import {LoadingData} from '../../../components/LoadingData'
import {MotifRefusForm} from './components/MotifRefusForm'

const MotifRefusEditPage = () => {
  const navigate = useNavigate();
  let { motifId } = useParams();
  const [data, setData] = useState<ModeleMotif>(modeleMotifRefusInitValues);
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getMotifData()
  }, [motifId]);

  const getMotifData = () => {
    getOneMotif(motifId).then(motifRequest => {
      if (motifRequest?.status === 200) {
        if (motifRequest?.data?.id !== undefined && motifRequest?.data?.id !== null) {
          const updatedData = Object.assign({...data}, motifRequest?.data)
          setData({...updatedData})
        }
        setLoading(false);
      } else {
        navigate(`/motif-refus`);
      }
    }).catch((e) => {
      setLoading(false);
      navigate(`/motif-refus`);
    });
  }

  const submitForm = async (fieldsToUpdate: Partial<ModeleMotif>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleMotifRefusInitValues}, fieldsToUpdate)

    var requestOk = false;
    try {
      const genreRequest = await editMotif(motifId, updatedData);
      if (genreRequest?.status === 200) {
        requestOk = true;
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback();
      if (requestOk) {
        setData({...updatedData})
        navigate(`/motif-refus`);
      }
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div
          className='card-header border-0'
        >
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Modifier un motif</h3>
          </div>
        </div>

        <div>
          {loading
            ?
            <LoadingData/>
            :
            <MotifRefusForm  motifId={motifId} data={data} submitForm={submitForm}/>
          }
        </div>
      </div>
    </>
  )
}

export default MotifRefusEditPage
